export default "__VITE_ASSET__29toxthg__"